<template>
  <tbody>
  <tr
      v-if="rowObject.type ==='workShift'" class="table-row-style"
      @click="handle(rowObject.shift)">
    <td v-if="rowObject.editedByAdmin" style="color:red; font-weight: bold">! {{ rowObject.customerName }}</td>
    <td v-if="!rowObject.editedByAdmin">{{ rowObject.customerName }}</td>
    <td :bgcolor="rowObject.color" :style="{'color': rowObject.textColor}">
      {{ rowObject.title }}
    </td>
    <td>{{ handleDateConversion(rowObject.date) }}</td>
    <td>
      <span>
        {{ rowObject.hours | convertDotToCommaInNumber }}u
      </span>
    </td>
  </tr>
  <tr
      v-else-if="rowObject.type ==='absence'" class="table-row-style"
      @click="handle(rowObject.shift)">
    <td v-if="rowObject.editedByAdmin" style="color:red; font-weight: bold">!</td>
    <td v-if="!rowObject.editedByAdmin"></td>
    <td :bgcolor="rowObject.color" :style="{'color': rowObject.textColor}">
      {{ rowObject.title }}
    </td>
    <td>{{ handleDateConversion(rowObject.date) }}</td>
    <td>
      <span class="color-red">
        {{ rowObject.hours | convertDotToCommaInNumber }}u
      </span>
    </td>
  </tr>
  <tr>
    <td colspan="6" class="p-0">
      <component
          :is="chosenComponent" :rowObject="rowObject"
          @shiftsChanged="handle"/>
    </td>
  </tr>

  </tbody>
</template>

<script>
import moment from "moment";
import {mapGetters} from "vuex";
import EditWorkedShift from "./EditWorkedShift";
import EditAbsence from "./EditAbsence";

export default {
  name: "TableRow",
  components: {
    EditWorkedShift,
    EditAbsence
  },
  props: ['rowObject'],
  data: () => {
    return {
      editorOpen: false
    };
  },
  computed: {
    ...mapGetters({
      completed: 'timesheet/completed'
    }),
    chosenComponent: function () {
      return this.editorOpen ? this.chooseComponent(this.rowObject) : "";
    },
  },
  methods: {
    handle() {
      if (!this.completed) {
        this.editorOpen = !this.editorOpen;
      }
    },
    handleDateConversion(start) {
      const DateToMoment = moment(start).locale('nl');
      return DateToMoment.format("dd DD-MM");
    },
    getFirstPartBeforeWhiteSpace(value) {
      return value.split(/(\s+|\[)/)[0];
    },
    chooseComponent(rowObject) {
      if (rowObject.type === 'workShift') {
        return 'EditWorkedShift';
      }
      if (rowObject.type === 'absence') {
        return 'EditAbsence';
      }
    },
  },
};

</script>

<style scoped>
.table-row-style:hover {
  background-color: #EEEEEE;
}

td {
  padding: 0.5rem 0;
}

.color-red {
  color: red;
}

</style>
